/** Обёртка над Telegram Web App SDK — безопасно работает и в обычном браузере */

export const tg = () => window?.Telegram?.WebApp || null;

export const isTelegram = () => {
  const t = tg();
  return !!(t && t.initData && t.initData.length > 0);
};

export const tgInit = () => {
  const t = tg();
  if (!t) return;
  try {
    t.ready();
    t.expand();
    if (t.setHeaderColor) t.setHeaderColor('#FF6B35');
    if (t.enableClosingConfirmation) t.enableClosingConfirmation();
  } catch {
    /* игнорируем — работаем как обычный сайт */
  }
};

export const haptic = (type = 'light') => {
  const t = tg();
  if (!t?.HapticFeedback) return;
  try {
    if (['error', 'success', 'warning'].includes(type)) {
      t.HapticFeedback.notificationOccurred(type);
    } else {
      t.HapticFeedback.impactOccurred(type);
    }
  } catch {
    /* no-op */
  }
};

export const tgBackButton = (onClick) => {
  const t = tg();
  if (!t?.BackButton) return () => {};
  try {
    t.BackButton.show();
    t.BackButton.onClick(onClick);
    return () => {
      t.BackButton.offClick(onClick);
      t.BackButton.hide();
    };
  } catch {
    return () => {};
  }
};

export const tgMainButton = ({ text, onClick, show = true, color = '#FF6B35' }) => {
  const t = tg();
  if (!t?.MainButton) return () => {};
  try {
    t.MainButton.setParams({ text, color, text_color: '#ffffff' });
    t.MainButton.onClick(onClick);
    if (show) t.MainButton.show();
    else t.MainButton.hide();
    return () => {
      t.MainButton.offClick(onClick);
      t.MainButton.hide();
    };
  } catch {
    return () => {};
  }
};
